import { FC } from 'react';
import { useClassNamesWithStyle } from '@edikk-edikk/country-frontend';
import homeBackgroundCss from '#home/components/background/assets/home-background.module.scss';

type PropsType = {
  src: string;
};

const BackgroundImage: FC<PropsType> = ({
  src,
}) => {
  const classNamesWithStyle = useClassNamesWithStyle();

  return (
    <img
      src={src}
      className={classNamesWithStyle(
        homeBackgroundCss.homeBackground__image,
        homeBackgroundCss.homeBackground__image_styleDefault,
        homeBackgroundCss.homeBackground__image_styleRed,
      )}
      alt="Main"
      fetchPriority="high"
    />
  );
};

export { BackgroundImage };
